<template>
<div>

  <h2 class="header py-5">法人アカウント登録</h2>

  <div v-if="contacted" class="p-5 text-center">

    <h4 class="bold my-4">登録申請を承りました。</h4>

    <div class="mt-5 mb-4">
      ご入力いただいたメールアドレス<span v-if="contact.email">（{{ contact.email }}）</span>宛に<br v-if="contact.email" />
      ご確認のメールをお送りいたしました。<br />
      いただいた内容については、１営業日以内にメールまたはお電話にてご連絡をさせていただきます。
    </div>

    <a href="/">> TOPへ戻る</a>

    <div class="white-box p-4 w-responsive m-auto my-4">
      <h3 class="p-reservation__title">
        以下から打ち合わせが<br class="u-pc-hidden">簡単に予約できます。
      </h3>
      <h6 class="mt-2 mb-4">30分ほどのWEB会議でサービス説明を<br class="u-pc-hidden">させていただきます。<br>ご都合の良い日時を選択ください。</h6>

      <div class="p-reservation__schedule">
        <iframe src="https://mieruca-connect-client.youcanbook.me/?noframe=true&skipHeaderFooter=true"
          id="ycbmiframemieruca-connect-client"
          style="width:100%;height:1000px;border:0px;background-color:transparent;" frameborder="0"
          allowtransparency="true"></iframe>
      </div>
    </div>

  </div>
  <div v-else>

    <div class="white-box w-responsive mx-auto p-5 mt-2">

      <form class="w-100" @submit.prevent="sendContact">

        <mdb-row class="align-items-center">
          <label for="company_name" class="grey-text text-left w-25">会社名<span class="red">※</span></label>
          <mdb-col>
            <mdb-input
              type="text"
              id="company_name"
              v-model="contact.company_name"
              maxlength="50"
              placeholder="株式会社Faber Company"
              required />
            </mdb-col>
        </mdb-row>
        <hr>
        <mdb-row class="align-items-center">
          <label for="family_name" class="grey-text text-left w-25">氏名<span class="red">※</span></label>
          <mdb-col class="d-flex">
            <mdb-input
              type="text"
              id="family_name"
              v-model="contact.family_name"
              maxlength="50"
              placeholder="山田"
              required/>
            <mdb-input
              type="text"
              id="first_name"
              v-model="contact.first_name"
              maxlength="50"
              placeholder="太郎"
              required/>
          </mdb-col>
        </mdb-row>
        <hr>
        <mdb-row class="align-items-center">
          <label for="tel" class="grey-text text-left w-25">電話番号<span class="red">※</span></label>
          <mdb-col>
            <mdb-input
              type="tel"
              id="tel"
              v-model="contact.tel"
              pattern="\d{10,11}"
              placeholder="0312345678"
              required />
          </mdb-col>
        </mdb-row>
        <hr>
        <mdb-row class="align-items-center">
          <label for="email" class="grey-text text-left w-25">メールアドレス<span class="red">※ </span></label>
          <mdb-col>
            <mdb-input
              type="email"
              id="email"
              v-model="contact.email"
              placeholder="example@fabercompany.co.jp"
              required />
          </mdb-col>
        </mdb-row>
        <div v-if="error" class="small text-danger text-center mt-2">{{ error }}</div>
        <hr>
        <mdb-row>
          <label for="defaultFormRegisterTel" class="grey-text text-left w-25">ご質問・ご要望等</label>
          <mdb-col>
            <mdb-textarea v-model="contact.description" :rows="10" />
          </mdb-col>
        </mdb-row>

        <hr class="mb-4">
        <div class="form-check text-center">
          <label class="form-check-label">
            <input class="form-check-input" type="checkbox" required />
            <a href="/term-client/" target="_blank">利用規約</a> / <a href="/privacy_policy/" target="_blank">個人情報の取り扱い</a>について同意する
          </label>
        </div>

        <input type="submit" id="submit" />
      </form>
      <div class="mt-4 text-center">
        <mdb-btn class="c-button c-button-simple c-button--orange bottom-button" @click="submit" rounded>＞ 送信する</mdb-btn><br>
      </div>
    </div>

  </div>
</div>

</template>

<style scoped>
.header {
  background: #D4F7F2;
  color: #26A388;
}
ul, ol {
  list-style: none;
}
h4 + div {
  line-height: 2;
}
h6 {
  line-height: 1.6;
}
.inline-block {
  display: inline-block;
}

.p-step {
  margin-bottom: 2em;
  display: -webkit-box;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
}
.p-step__area {
  width: 100%;
  max-width: 115px;
  text-align: center;
  position: relative;
  padding-bottom: calc(0.6666666667em + 15px);
}
.p-step__area.is-active::before {
  content: "";
  display: block;
  width: 100%;
  height: 3px;
  background: -webkit-gradient(linear, left top, right top, color-stop(50%, #00b48c), to(transparent));
  background: linear-gradient(to right, #00b48c 50%, transparent 100%);
  transform: translate(0, -50%) translate(50%, 3.5px);
  -webkit-transform: translate(0, -50%) translate(50%, 3.5px);
  -ms-transform: translate(0, -50%) translate(50%, 3.5px);
  position: absolute;
  bottom: calc(15px / 2);
  z-index: 1;
}
.p-step__area.is-active .p-step__dot {
  border-color: #00b48c;
  background-color: #00b48c;
}
.p-step__dot {
  display: block;
  width: 15px;
  height: 15px;
  margin: 0.6666666667em auto 0;
  border: 1px solid #999;
  border-radius: 50%;
  background-color: #fff;
  position: absolute;
  left: 50%;
  bottom: 0;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  z-index: 2;
}
.p-step__area::after {
  content: "";
  display: block;
  width: 100%;
  height: 3px;
  background-color: #ccc;
  transform: translate(0, -50%) translate(50%, 3.5px);
  -webkit-transform: translate(0, -50%) translate(50%, 3.5px);
  -ms-transform: translate(0, -50%) translate(50%, 3.5px);
  position: absolute;
  bottom: calc(15px / 2);
  z-index: 0;
}
.p-step__area:last-child:after {
  display:none;
}
.p-reservation__title {
  color: #1c9c7f;
  font-size: 1.375rem;
  margin: 1.81818em 0;
  display: inline-block;
  position: relative;
  padding-left: 3.86364em;
}
.p-reservation__title::before {
  content: '';
  display: inline-block;
  width: 70px;
  padding-top: 70px;
  background-image: url(/image/icon_operator.png);
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
}
.u-visually-hidden {
  position: absolute;
  white-space: nowrap;
  width: 1px;
  height: 1px;
  overflow: hidden;
  border: 0;
  padding: 0;
  clip: rect(0 0 0 0);
  -webkit-clip-path: inset(50%);
  clip-path: inset(50%);
}
.u-pc-hidden {
    display: none;
}
.red {
  color: red;
  margin-left: 6px;
}
</style>
<script>
import { ref, onMounted, watch, nextTick} from "vue";
import http from "axios";
import { useForward } from "@/common/page.js";

export default{
  layout: {
    name: "default",
    props: {
      pageType: 'business'
    }
  },
  setup() {
    const contact = ref({});
    const contacted = ref(false);
    const error = ref(null);
    const { checkQuery, forward } = useForward();

    watch(() => contacted.value, () => {
      nextTick(() => {
        window.scrollTo({ top: 0 });
      });
    });

    checkQuery('thanks', () => { contacted.value = true });

    const sendContact = async () => {
      try {
        let r = await http.post("/api/company/contact", contact.value);
        if (r.data.error) {
          error.value = '既に登録されたメールアドレスです';
          return;
        }
        contacted.value = true;
        forward('thanks');
      } catch {
        console.log('法人アカウント登録の申込みに失敗しました');
      }
    };

    onMounted(() => {
      if (window.addEventListener) {
        window.addEventListener("message", event => {
          if (event.origin === "https://mieruca-connect-client.youcanbook.me") {
            document.getElementById("ycbmiframemieruca-connect-client").style.height = event.data + "px";
          }
        }, false);
      }
    });

    return { contact, contacted, error, sendContact };
  }
};
</script>
